export const ERROR_ONBOARDING_NOT_FOUND = 'errors.tokenInvalid'
export const ERROR_CALLBACK_FAILED = 'errors.callbackFailed'
